<header
  class="flex flex-wrap items-center gap-x-4 gap-y-3 border-b border-neutral-gray30 bg-neutral-white px-4 py-4 shadow-sm sm:px-8 sm:py-5">
  <div class="flex min-w-0 items-center gap-2 sm:gap-4">
    <button
      type="button"
      data-testid="header-menu"
      (click)="menuClick.emit()"
      [attr.aria-label]="'shared.components.header.menu' | translate"
      [attr.aria-expanded]="sidebarOpen"
      aria-controls="app-sidebar"
      class="-ml-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-neutral-gray70 hover:bg-neutral-gray20 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-90 lg:hidden">
      <img src="assets/icons/menu.svg" alt="" aria-hidden="true" class="h-6 w-6" />
    </button>
    @if (showBackButton) {
    <button
      data-testid="header-back"
      (click)="backClick.emit()"
      class="flex min-h-11 shrink-0 items-center justify-center rounded-lg border border-neutral-gray30 px-3 py-2 text-neutral-gray70 hover:bg-neutral-gray10">
      <img src="assets/images/chevron-left.svg" alt="" aria-hidden="true" class="h-4 w-4" />
      <span class="ml-2 hidden sm:inline">{{ 'shared.components.header.back' | translate }}</span>
      <span class="sr-only sm:hidden">{{ 'shared.components.header.back' | translate }}</span>
    </button>
    }
    <h1 class="min-w-20 truncate text-lg font-semibold text-neutral-gray70 sm:text-xl">
      {{ title | translate }}
    </h1>
  </div>
  @if (subtitle) {
  <span
    data-testid="header-subtitle"
    class="w-full min-w-0 break-all rounded bg-neutral-gray20 p-2 text-sm font-semibold text-neutral-gray70 sm:text-base lg:w-auto lg:truncate">
    #{{ subtitle }}
  </span>
  }

  <div data-testid="header-actions" class="ml-auto flex flex-wrap items-center justify-end gap-2 sm:gap-4">
    @for (button of buttons; track button) {
    <button
      [id]="button?.id"
      (click)="button?.action()"
      [disabled]="button?.disabled"
      [ngClass]="{
        'bg-primary-90 text-neutral-white hover:bg-primary-70 disabled:bg-primary-30 disabled:hover:bg-primary-30':
          button?.buttonType === 'primary',
        'border border-neutral-gray30 bg-white text-neutral-gray70 hover:bg-neutral-gray10 disabled:bg-neutral-gray10 disabled:opacity-50 disabled:hover:bg-neutral-gray10':
          button?.buttonType === 'secondary'
      }"
      class="flex min-h-11 items-center gap-2 rounded-lg px-3 py-2.5 text-sm font-medium tracking-tight shadow transition disabled:cursor-not-allowed sm:gap-3 sm:p-3 sm:text-base">
      @if (button?.icon) {
      <img [src]="button?.icon" alt="" aria-hidden="true" class="h-5 w-5 shrink-0 sm:h-6 sm:w-6" />
      }
      {{ button.label | translate }}
    </button>
    }
  </div>
</header>
